import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSurvey = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 120 120",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M45.625 13.563c-12.006 0-21.791 9.782-21.791 21.789 0 12.006 9.785 21.789 21.791 21.789s21.79-9.783 21.79-21.79c0-12.006-9.784-21.788-21.79-21.788zm0 4.718a17.033 17.033 0 0117.068 17.07c0 9.456-7.613 17.07-17.068 17.07a17.035 17.035 0 01-17.07-17.07c0-9.455 7.615-17.07 17.07-17.07z",
			overflow: "visible"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M43.645 30.373a3.508 3.508 0 01-3.508 3.509 3.508 3.508 0 01-3.509-3.509 3.508 3.508 0 013.509-3.508 3.508 3.508 0 013.508 3.508z" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.338 38.463a2.36 2.36 0 00-1.664.701 2.36 2.36 0 00.017 3.338c3.3 3.262 7.83 4.66 12.196 4.588 4.365-.072 8.68-1.581 11.683-4.602a2.36 2.36 0 00-.007-3.338 2.36 2.36 0 00-3.338.008c-1.925 1.935-5.121 3.157-8.416 3.211-3.295.055-6.575-1.025-8.8-3.224a2.36 2.36 0 00-1.671-.682z",
			overflow: "visible"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M55.508 30.373a3.508 3.508 0 01-3.509 3.509 3.508 3.508 0 01-3.508-3.509A3.508 3.508 0 0152 26.865a3.508 3.508 0 013.509 3.508z" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.135 63.707c-12.006 0-21.79 9.783-21.79 21.79 0 12.005 9.784 21.79 21.79 21.79 12.006 0 21.79-9.785 21.79-21.79 0-12.007-9.784-21.79-21.79-21.79zm0 4.72c9.455 0 17.07 7.614 17.07 17.07 0 9.454-7.615 17.07-17.07 17.07a17.033 17.033 0 01-17.069-17.07 17.032 17.032 0 0117.069-17.07z",
			overflow: "visible"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M44.156 80.518a3.508 3.508 0 01-3.508 3.509 3.508 3.508 0 01-3.509-3.509 3.508 3.508 0 013.509-3.508 3.508 3.508 0 013.508 3.508z" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.398 88.611c-4.365-.072-8.896 1.326-12.195 4.588a2.36 2.36 0 00-.02 3.338 2.36 2.36 0 003.338.018c2.225-2.2 5.504-3.28 8.8-3.225 3.294.055 6.491 1.276 8.415 3.211a2.36 2.36 0 003.336.01 2.36 2.36 0 00.01-3.338c-3.004-3.02-7.318-4.53-11.684-4.602z",
			overflow: "visible"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M56.019 80.518a3.508 3.508 0 01-3.509 3.509 3.508 3.508 0 01-3.508-3.509 3.508 3.508 0 013.508-3.508 3.508 3.508 0 013.509 3.508z" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M94.438 26.623a2.36 2.36 0 00-1.479 1.037L82.693 43.81l-6.445-6.445a2.36 2.36 0 00-3.336 0 2.36 2.36 0 000 3.336l8.527 8.528a2.36 2.36 0 003.66-.403l11.844-18.635a2.36 2.36 0 00-.726-3.255 2.36 2.36 0 00-1.78-.313zM75.21 81.824a2.36 2.36 0 00-2.358 2.36 2.36 2.36 0 002.359 2.359h18.793a2.36 2.36 0 002.36-2.36 2.36 2.36 0 00-2.36-2.359z",
			overflow: "visible"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.934 0C14.47 0 10 4.471 10 9.934v100.134c0 5.463 4.471 9.932 9.934 9.932h79.289c5.462 0 9.931-4.47 9.931-9.932V9.934c0-5.463-4.47-9.934-9.931-9.934zm0 4.72h79.289c2.929 0 5.213 2.284 5.213 5.214v100.134c0 2.93-2.284 5.213-5.213 5.213h-79.29c-2.929 0-5.212-2.284-5.212-5.213V9.934c0-2.93 2.283-5.213 5.213-5.213z",
			overflow: "visible"
		})
	]
});
export default SvgSurvey;
